// 与教师包、SDK 的密码校验规则保持一致。
export function validatePassword(password: string) {
  if (/^\S*\S*$/.test(password)) {
    if (password.length < 8 || password.length > 20 || /\s/.test(password)) {
      return false
    }
    let count = 0
    if (/\d/.test(password)) {
      count++
    }
    if (/[A-Z]/.test(password)) {
      count++
    }
    if (/[a-z]/.test(password)) {
      count++
    }
    if (/[^0-9]/.test(password) && /[^A-Z]/.test(password) && /[^a-z]/.test(password)) {
      count++
    }
    if (count >= 2) {
      return true
    }
  }
  return false
}
